// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from "./core/CancelablePromise";
import { OpenAPI } from "./core/OpenAPI";
import { request as __request } from "./core/request";
import type {
  CreateKnowledgeBaseFileUploadData,
  CreateKnowledgeBaseFileUploadResponse,
  GetKnowledgeBasesForUserData,
  GetKnowledgeBasesForUserResponse,
  CreateKnowledgeBaseData,
  CreateKnowledgeBaseResponse,
  GetKnowledgeBaseData,
  GetKnowledgeBaseResponse,
  UserUpdateKnowledgeBaseData,
  UserUpdateKnowledgeBaseResponse,
  FindKnowledgeBaseFilesData,
  FindKnowledgeBaseFilesResponse,
  GetKnowledgeBaseFileData,
  GetKnowledgeBaseFileResponse,
  UserUpdateKnowledgeBaseFileData,
  UserUpdateKnowledgeBaseFileResponse,
  DeleteKnowledgeBaseFileData,
  DeleteKnowledgeBaseFileResponse,
  GetKnowledgeBaseFileUrlData,
  GetKnowledgeBaseFileUrlResponse,
  GetKnowledgeBaseFileAudioTranscriptUrlData,
  GetKnowledgeBaseFileAudioTranscriptUrlResponse,
  MoveKnowledgeBaseFilesData,
  MoveKnowledgeBaseFilesResponse,
  FindKnowledgeBaseFoldersData,
  FindKnowledgeBaseFoldersResponse,
  CreateKnowledgeBaseFolderData,
  CreateKnowledgeBaseFolderResponse,
  GetKnowledgeBaseFolderData,
  GetKnowledgeBaseFolderResponse,
  UserUpdateKnowledgeBaseFolderData,
  UserUpdateKnowledgeBaseFolderResponse,
  DeleteKnowledgeBaseFolderData,
  DeleteKnowledgeBaseFolderResponse,
  MoveKnowledgeBaseFoldersData,
  MoveKnowledgeBaseFoldersResponse,
  GetKnowledgeBaseFileSolverTasksForUserData,
  GetKnowledgeBaseFileSolverTasksForUserResponse,
  GetKnowledgeBaseLayerConnectionsData,
  GetKnowledgeBaseLayerConnectionsResponse,
  CreateChatSessionData,
  CreateChatSessionResponse,
  AskKnowledgeBaseChatStreamData,
  AskKnowledgeBaseChatStreamResponse,
  GetCurrentUserResponse,
  CreateCheckoutSessionData,
  CreateCheckoutSessionResponse,
  GetSubscriptionUsageForUserResponse,
  ClerkUserWebhookResponse,
  StripeWebhookResponse,
  CreateSolverTaskData,
  CreateSolverTaskResponse,
  GetSolverTaskData,
  GetSolverTaskResponse,
  GetApplicationAuthData,
  GetApplicationAuthResponse,
  HandleGoogleAuthCallbackData,
  HandleGoogleAuthCallbackResponse,
  SearchLayersData,
  SearchLayersResponse,
  GetLayerData,
  GetLayerResponse,
  EditLayerData,
  EditLayerResponse,
  GetUserLayerStarData,
  GetUserLayerStarResponse,
  AddUserLayerStarData,
  AddUserLayerStarResponse,
  RemoveUserLayerStarData,
  RemoveUserLayerStarResponse,
  GetLayerConnectionsData,
  GetLayerConnectionsResponse,
  GetLayerUserConnectionsData,
  GetLayerUserConnectionsResponse,
  GetLayersForUserResponse,
  CreateLayerData,
  CreateLayerResponse,
  EditLayerOverviewData,
  EditLayerOverviewResponse,
  SubscribeToLayerData,
  SubscribeToLayerResponse,
  UnsubscribeToLayerData,
  UnsubscribeToLayerResponse,
  PublishToLayerData,
  PublishToLayerResponse,
  UnpublishToLayerData,
  UnpublishToLayerResponse,
} from "./types.gen";

export class KnowledgeBaseService {
  /**
   * @param data The data for the request.
   * @param data.kbId
   * @param data.requestBody
   * @returns CreateKnowledgeBaseFileUploadResponseDto
   * @throws ApiError
   */
  public static createKnowledgeBaseFileUpload(
    data: CreateKnowledgeBaseFileUploadData,
  ): CancelablePromise<CreateKnowledgeBaseFileUploadResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/knowledge-bases/{kbId}/files/upload",
      path: {
        kbId: data.kbId,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.permission
   * @param data.nextCursor
   * @returns GetKnowledgeBasesForUserResponseDto
   * @throws ApiError
   */
  public static getKnowledgeBasesForUser(
    data: GetKnowledgeBasesForUserData,
  ): CancelablePromise<GetKnowledgeBasesForUserResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/knowledge-bases",
      query: {
        permission: data.permission,
        limit: data.limit,
        nextCursor: data.nextCursor,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns KnowledgeBaseEntity
   * @throws ApiError
   */
  public static createKnowledgeBase(
    data: CreateKnowledgeBaseData,
  ): CancelablePromise<CreateKnowledgeBaseResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/knowledge-bases",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.kbId
   * @param data.includeLayerConnections
   * @returns KnowledgeBaseEntity
   * @throws ApiError
   */
  public static getKnowledgeBase(
    data: GetKnowledgeBaseData,
  ): CancelablePromise<GetKnowledgeBaseResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/knowledge-bases/{kbId}",
      path: {
        kbId: data.kbId,
      },
      query: {
        includeLayerConnections: data.includeLayerConnections,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.kbId
   * @param data.requestBody
   * @returns KnowledgeBaseEntity
   * @throws ApiError
   */
  public static userUpdateKnowledgeBase(
    data: UserUpdateKnowledgeBaseData,
  ): CancelablePromise<UserUpdateKnowledgeBaseResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/v1/knowledge-bases/{kbId}",
      path: {
        kbId: data.kbId,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.kbId
   * @param data.limit
   * @param data.parentFolderId
   * @param data.location
   * @param data.includeUploader
   * @param data.includeMetadata
   * @param data.nextCursor
   * @returns FindKnowledgeBaseFilesResponseDto
   * @throws ApiError
   */
  public static findKnowledgeBaseFiles(
    data: FindKnowledgeBaseFilesData,
  ): CancelablePromise<FindKnowledgeBaseFilesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/knowledge-bases/{kbId}/files",
      path: {
        kbId: data.kbId,
      },
      query: {
        parentFolderId: data.parentFolderId,
        location: data.location,
        includeUploader: data.includeUploader,
        includeMetadata: data.includeMetadata,
        limit: data.limit,
        nextCursor: data.nextCursor,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.fileId
   * @param data.kbId
   * @param data.location
   * @param data.includeThumbnail
   * @returns KnowledgeBaseFileEntity
   * @throws ApiError
   */
  public static getKnowledgeBaseFile(
    data: GetKnowledgeBaseFileData,
  ): CancelablePromise<GetKnowledgeBaseFileResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/knowledge-bases/{kbId}/files/{fileId}",
      path: {
        fileId: data.fileId,
        kbId: data.kbId,
      },
      query: {
        location: data.location,
        includeThumbnail: data.includeThumbnail,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.fileId
   * @param data.kbId
   * @param data.requestBody
   * @returns KnowledgeBaseFileEntity
   * @throws ApiError
   */
  public static userUpdateKnowledgeBaseFile(
    data: UserUpdateKnowledgeBaseFileData,
  ): CancelablePromise<UserUpdateKnowledgeBaseFileResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/v1/knowledge-bases/{kbId}/files/{fileId}",
      path: {
        fileId: data.fileId,
        kbId: data.kbId,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.fileId
   * @param data.kbId
   * @returns KnowledgeBaseFileEntity
   * @throws ApiError
   */
  public static deleteKnowledgeBaseFile(
    data: DeleteKnowledgeBaseFileData,
  ): CancelablePromise<DeleteKnowledgeBaseFileResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/knowledge-bases/{kbId}/files/{fileId}",
      path: {
        fileId: data.fileId,
        kbId: data.kbId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.fileId
   * @param data.kbId
   * @param data.inline
   * @param data.source
   * @returns GetKnowledgeBaseFileUrlResponseDto
   * @throws ApiError
   */
  public static getKnowledgeBaseFileUrl(
    data: GetKnowledgeBaseFileUrlData,
  ): CancelablePromise<GetKnowledgeBaseFileUrlResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/knowledge-bases/{kbId}/files/{fileId}/file-url",
      path: {
        fileId: data.fileId,
        kbId: data.kbId,
      },
      query: {
        inline: data.inline,
        source: data.source,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.fileId
   * @param data.kbId
   * @param data.inline
   * @returns GetKnowledgeBaseFileAudioTranscriptUrlResponseDto
   * @throws ApiError
   */
  public static getKnowledgeBaseFileAudioTranscriptUrl(
    data: GetKnowledgeBaseFileAudioTranscriptUrlData,
  ): CancelablePromise<GetKnowledgeBaseFileAudioTranscriptUrlResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/knowledge-bases/{kbId}/files/{fileId}/audio-transcript-url",
      path: {
        fileId: data.fileId,
        kbId: data.kbId,
      },
      query: {
        inline: data.inline,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.kbId
   * @param data.requestBody
   * @returns KnowledgeBaseFileEntity
   * @throws ApiError
   */
  public static moveKnowledgeBaseFiles(
    data: MoveKnowledgeBaseFilesData,
  ): CancelablePromise<MoveKnowledgeBaseFilesResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/knowledge-bases/{kbId}/files/move",
      path: {
        kbId: data.kbId,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.kbId
   * @param data.limit
   * @param data.parentFolderId
   * @param data.location
   * @param data.includeUploader
   * @param data.includeNestedParentFolders
   * @param data.nextCursor
   * @returns FindKnowledgeBaseFoldersResponseDto
   * @throws ApiError
   */
  public static findKnowledgeBaseFolders(
    data: FindKnowledgeBaseFoldersData,
  ): CancelablePromise<FindKnowledgeBaseFoldersResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/knowledge-bases/{kbId}/folders",
      path: {
        kbId: data.kbId,
      },
      query: {
        parentFolderId: data.parentFolderId,
        location: data.location,
        includeUploader: data.includeUploader,
        includeNestedParentFolders: data.includeNestedParentFolders,
        limit: data.limit,
        nextCursor: data.nextCursor,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.kbId
   * @param data.requestBody
   * @returns KnowledgeBaseFolderEntity
   * @throws ApiError
   */
  public static createKnowledgeBaseFolder(
    data: CreateKnowledgeBaseFolderData,
  ): CancelablePromise<CreateKnowledgeBaseFolderResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/knowledge-bases/{kbId}/folders",
      path: {
        kbId: data.kbId,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.folderId
   * @param data.kbId
   * @param data.location
   * @param data.includeUploader
   * @param data.includeNestedParentFolders
   * @returns KnowledgeBaseFolderEntity
   * @throws ApiError
   */
  public static getKnowledgeBaseFolder(
    data: GetKnowledgeBaseFolderData,
  ): CancelablePromise<GetKnowledgeBaseFolderResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/knowledge-bases/{kbId}/folders/{folderId}",
      path: {
        folderId: data.folderId,
        kbId: data.kbId,
      },
      query: {
        location: data.location,
        includeUploader: data.includeUploader,
        includeNestedParentFolders: data.includeNestedParentFolders,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.folderId
   * @param data.kbId
   * @param data.requestBody
   * @returns KnowledgeBaseFolderEntity
   * @throws ApiError
   */
  public static userUpdateKnowledgeBaseFolder(
    data: UserUpdateKnowledgeBaseFolderData,
  ): CancelablePromise<UserUpdateKnowledgeBaseFolderResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/v1/knowledge-bases/{kbId}/folders/{folderId}",
      path: {
        folderId: data.folderId,
        kbId: data.kbId,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.folderId
   * @param data.kbId
   * @returns KnowledgeBaseFolderEntity
   * @throws ApiError
   */
  public static deleteKnowledgeBaseFolder(
    data: DeleteKnowledgeBaseFolderData,
  ): CancelablePromise<DeleteKnowledgeBaseFolderResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/knowledge-bases/{kbId}/folders/{folderId}",
      path: {
        folderId: data.folderId,
        kbId: data.kbId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.kbId
   * @param data.requestBody
   * @returns KnowledgeBaseFolderEntity
   * @throws ApiError
   */
  public static moveKnowledgeBaseFolders(
    data: MoveKnowledgeBaseFoldersData,
  ): CancelablePromise<MoveKnowledgeBaseFoldersResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/knowledge-bases/{kbId}/folders/move",
      path: {
        kbId: data.kbId,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.fileId
   * @param data.kbId
   * @param data.limit
   * @param data.nextCursor
   * @returns GetKnowledgeBaseFileSolverTasksForUserResponseDto
   * @throws ApiError
   */
  public static getKnowledgeBaseFileSolverTasksForUser(
    data: GetKnowledgeBaseFileSolverTasksForUserData,
  ): CancelablePromise<GetKnowledgeBaseFileSolverTasksForUserResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/knowledge-bases/{kbId}/files/{fileId}/solver-tasks",
      path: {
        fileId: data.fileId,
        kbId: data.kbId,
      },
      query: {
        limit: data.limit,
        nextCursor: data.nextCursor,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.kbId
   * @param data.layerId
   * @param data.includeLayer
   * @param data.role
   * @returns KnowledgeBaseLayerConnectionEntity
   * @throws ApiError
   */
  public static getKnowledgeBaseLayerConnections(
    data: GetKnowledgeBaseLayerConnectionsData,
  ): CancelablePromise<GetKnowledgeBaseLayerConnectionsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/knowledge-bases/{kbId}/layers/connections",
      path: {
        kbId: data.kbId,
      },
      query: {
        layerId: data.layerId,
        includeLayer: data.includeLayer,
        role: data.role,
      },
    });
  }
}

export class ChatService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns ChatSessionEntity
   * @throws ApiError
   */
  public static createChatSession(
    data: CreateChatSessionData,
  ): CancelablePromise<CreateChatSessionResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/chat/session",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.chatSessionId
   * @param data.requestBody
   * @returns AskKnowledgeBaseChatResponse
   * @throws ApiError
   */
  public static askKnowledgeBaseChatStream(
    data: AskKnowledgeBaseChatStreamData,
  ): CancelablePromise<AskKnowledgeBaseChatStreamResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/chat/session/{chatSessionId}/ask/stream",
      path: {
        chatSessionId: data.chatSessionId,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class UserService {
  /**
   * @returns UserEntity
   * @throws ApiError
   */
  public static getCurrentUser(): CancelablePromise<GetCurrentUserResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/users",
    });
  }
}

export class SubscriptionService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns CheckoutSessionEntity
   * @throws ApiError
   */
  public static createCheckoutSession(
    data: CreateCheckoutSessionData,
  ): CancelablePromise<CreateCheckoutSessionResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/subscription/checkout",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @returns UserSubscriptionUsageEntity
   * @throws ApiError
   */
  public static getSubscriptionUsageForUser(): CancelablePromise<GetSubscriptionUsageForUserResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/subscription/usage",
    });
  }
}

export class ClerkWebhookService {
  /**
   * @returns UserEntity
   * @throws ApiError
   */
  public static clerkUserWebhook(): CancelablePromise<ClerkUserWebhookResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/webhooks/clerk/user",
    });
  }
}

export class StripeWebhookService {
  /**
   * @returns unknown
   * @throws ApiError
   */
  public static stripeWebhook(): CancelablePromise<StripeWebhookResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/webhooks/stripe/subscription",
    });
  }
}

export class SolverTaskService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns SolverTaskEntity
   * @throws ApiError
   */
  public static createSolverTask(
    data: CreateSolverTaskData,
  ): CancelablePromise<CreateSolverTaskResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/solver-tasks",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.solverTaskId
   * @param data.includeOutput
   * @returns SolverTaskEntity
   * @throws ApiError
   */
  public static getSolverTask(
    data: GetSolverTaskData,
  ): CancelablePromise<GetSolverTaskResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/solver-tasks/{solverTaskId}",
      path: {
        solverTaskId: data.solverTaskId,
      },
      query: {
        includeOutput: data.includeOutput,
      },
    });
  }
}

export class ConnectorService {
  /**
   * @param data The data for the request.
   * @param data.application
   * @returns ApplicationConnectionAuthEntity
   * @throws ApiError
   */
  public static getApplicationAuth(
    data: GetApplicationAuthData,
  ): CancelablePromise<GetApplicationAuthResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/connectors/auth",
      query: {
        application: data.application,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static handleGoogleAuthCallback(
    data: HandleGoogleAuthCallbackData,
  ): CancelablePromise<HandleGoogleAuthCallbackResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/connectors/auth/google-drive/callback",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class KnowledgeBaseLayerService {
  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.searchQuery
   * @param data.sortBy
   * @param data.isFeatured
   * @param data.nextCursor
   * @returns SearchLayersResponseDto
   * @throws ApiError
   */
  public static searchLayers(
    data: SearchLayersData,
  ): CancelablePromise<SearchLayersResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/layers/search",
      query: {
        searchQuery: data.searchQuery,
        sortBy: data.sortBy,
        isFeatured: data.isFeatured,
        limit: data.limit,
        nextCursor: data.nextCursor,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.layerId
   * @param data.includeOverview
   * @returns KnowledgeBaseLayerEntity
   * @throws ApiError
   */
  public static getLayer(
    data: GetLayerData,
  ): CancelablePromise<GetLayerResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/layers/{layerId}",
      path: {
        layerId: data.layerId,
      },
      query: {
        includeOverview: data.includeOverview,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.layerId
   * @param data.requestBody
   * @returns KnowledgeBaseLayerEntity
   * @throws ApiError
   */
  public static editLayer(
    data: EditLayerData,
  ): CancelablePromise<EditLayerResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/v1/layers/{layerId}",
      path: {
        layerId: data.layerId,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.layerId
   * @returns UserLayerStarEntity
   * @throws ApiError
   */
  public static getUserLayerStar(
    data: GetUserLayerStarData,
  ): CancelablePromise<GetUserLayerStarResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/layers/{layerId}/star",
      path: {
        layerId: data.layerId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.layerId
   * @returns unknown
   * @throws ApiError
   */
  public static addUserLayerStar(
    data: AddUserLayerStarData,
  ): CancelablePromise<AddUserLayerStarResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/v1/layers/{layerId}/star",
      path: {
        layerId: data.layerId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.layerId
   * @returns unknown
   * @throws ApiError
   */
  public static removeUserLayerStar(
    data: RemoveUserLayerStarData,
  ): CancelablePromise<RemoveUserLayerStarResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/layers/{layerId}/star",
      path: {
        layerId: data.layerId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.layerId
   * @param data.limit
   * @param data.role
   * @param data.nextCursor
   * @returns GetLayerConnectionsResponseDto
   * @throws ApiError
   */
  public static getLayerConnections(
    data: GetLayerConnectionsData,
  ): CancelablePromise<GetLayerConnectionsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/layers/{layerId}/connections",
      path: {
        layerId: data.layerId,
      },
      query: {
        role: data.role,
        limit: data.limit,
        nextCursor: data.nextCursor,
      },
    });
  }

  /**
   * This one fetches connections to knowledge bases the user has at least owner access to
   * @param data The data for the request.
   * @param data.layerId
   * @param data.limit
   * @param data.role
   * @param data.nextCursor
   * @returns GetLayerUserConnectionsResponseDto
   * @throws ApiError
   */
  public static getLayerUserConnections(
    data: GetLayerUserConnectionsData,
  ): CancelablePromise<GetLayerUserConnectionsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/layers/{layerId}/user-connections",
      path: {
        layerId: data.layerId,
      },
      query: {
        role: data.role,
        limit: data.limit,
        nextCursor: data.nextCursor,
      },
    });
  }

  /**
   * @returns GetLayersForUserResponseDto
   * @throws ApiError
   */
  public static getLayersForUser(): CancelablePromise<GetLayersForUserResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/layers",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns KnowledgeBaseLayerEntity
   * @throws ApiError
   */
  public static createLayer(
    data: CreateLayerData,
  ): CancelablePromise<CreateLayerResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/layers",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.layerId
   * @param data.requestBody
   * @returns KnowledgeBaseLayerEntity
   * @throws ApiError
   */
  public static editLayerOverview(
    data: EditLayerOverviewData,
  ): CancelablePromise<EditLayerOverviewResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/v1/layers/{layerId}/overview",
      path: {
        layerId: data.layerId,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns KnowledgeBaseLayerConnectionEntity
   * @throws ApiError
   */
  public static subscribeToLayer(
    data: SubscribeToLayerData,
  ): CancelablePromise<SubscribeToLayerResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/layers/subscribe",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static unsubscribeToLayer(
    data: UnsubscribeToLayerData,
  ): CancelablePromise<UnsubscribeToLayerResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/layers/unsubscribe",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns KnowledgeBaseLayerConnectionEntity
   * @throws ApiError
   */
  public static publishToLayer(
    data: PublishToLayerData,
  ): CancelablePromise<PublishToLayerResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/layers/publish",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static unpublishToLayer(
    data: UnpublishToLayerData,
  ): CancelablePromise<UnpublishToLayerResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/layers/unpublish",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}
